import { useQuery } from "react-query";
import { rolesGet, mainRolesGet } from "../api/role";

export const useGetRoles = (options = {}) => {
  return useQuery(["useGetRoles"], () => rolesGet(), {
    ...options,
  });
};

export const useGetMainRoles = (options = {}) => {
  return useQuery(["useGetMainRoles"], () => mainRolesGet(), {
    ...options,
  });
};

export default {
  useGetRoles,
  useGetMainRoles,
};
